/**
 * Texts for Careers page
 */
export const careersPageText = {
    title: 'Carreiras',
    titleMeta: 'Carreiras — Ofertas de emprego | CamDiab',
    descriptionMeta: 'Explore oportunidades de carreira na CamDiab. Junte-se à nossa equipa para melhorar a vida das pessoas com diabetes.',
    keywords: 'carreiras CamDiab, empregos, vagas, tecnologia diabetes',
    localeMeta: 'pt_PT',

    bannerTitle: 'Ofertas de emprego',
    bannerSubtitle: 'Tem interesse em juntar-se à nossa equipa?',
    heroNote: 'Todas as ofertas de emprego são publicadas em inglês.',

    introBody:
        'Se procura um novo desafio e gostaria de contribuir para uma mudança significativa, gostaríamos de o ouvir. Investimos nas pessoas, que são o coração da CamDiab. Os benefícios para os colaboradores foram concebidos para extrair o melhor de cada um:',

    benefitsTitle: '',
    benefits: [
        'Contribuição generosa do empregador para o fundo de pensões (incluindo regime de pensão com sacrifício salarial)',
        'Seguro de saúde privado e de viagem',
        'Seguro de vida',
        'Bónus anual discricionário',
        '29 dias de férias anuais, mais 8 feriados',
        'Remuneração competitiva',
        'Modelo de trabalho híbrido, com pelo menos um dia por semana no nosso escritório de Cambridge',
        'Oportunidade de trabalhar em tecnologia inovadora e transformar a gestão da diabetes',
    ],

    outroHtml:
        'Se tem paixão por gerar um impacto real, gostaríamos de o ouvir:<br/><br/><a href="mailto:hr@camdiab.com" class="careers-email-link">hr@camdiab.com</a>',

    /* Job listings. Use vacancies: [] to show only the “No current vacancies” accordion. */
    vacancies: [],

    emptyVacancyTitle: 'Sem vagas de momento',
    emptyVacancyBody:
        'Poderemos não estar a recrutar neste momento, mas a CamDiab está a crescer e estamos sempre interessados em ouvir pessoas que tenham paixão por melhorar a vida de quem vive com diabetes. Volte a consultar esta página para futuras oportunidades.',

    applyLabel: 'Candidatar-se agora',
};
